<script setup>
  const { item } = defineProps(['item']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <FighterStatCard :title="item.title" :subtitle="item.subtitle">
    <ul>
      <li v-for="{ label, value } in item.data">
        <label>{{ label }}</label>
        <h5>{{ value }}</h5>
      </li>
    </ul>
  </FighterStatCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .stat {
    ul {
      width: 100%;

      border: px(1) solid $black-5;

      display: grid;
      grid-template-columns: 1fr 1fr;

      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        padding: px(20) 0;

        &:nth-child(odd) {
          border-right: px(1) solid $black-5;
        }

        &:nth-child(n + 3) {
          border-top: px(1) solid $black-5;
        }

        label {
          @include industry-demi(px(10));
          color: $grey-2;
        }

        h5 {
          font-size: px(72);

          margin-top: px(-20);
          margin-bottom: px(-32);
        }
      }
    }
  }
</style>
